import React from 'react';
import { Section as StyledSection, SectionStyledProps } from './Section.styled';

export interface SectionProps extends SectionStyledProps {
  children: React.ReactNode;
  className?: string;
}

export function Section({ 
  children, 
  className, 
  withTopBorder, 
  marginTop, 
  paddingTop 
}: SectionProps) {
  return (
    <StyledSection
      className={`section ${className ? ` ${className}` : ''}`}
      withTopBorder={withTopBorder}
      marginTop={marginTop}
      paddingTop={paddingTop}
    >
      {children}
    </StyledSection>
  );
}
